// extracted by mini-css-extract-plugin
export var BrowserWindow = "BrowserWindow-module--BrowserWindow--UhKpP";
export var Toolbar = "BrowserWindow-module--Toolbar--XEMaj";
export var ActionButtons = "BrowserWindow-module--ActionButtons--udri+";
export var ActionButton = "BrowserWindow-module--ActionButton--xIdkw";
export var Close = "BrowserWindow-module--Close--druzR";
export var Minimize = "BrowserWindow-module--Minimize--Kj00O";
export var Maximize = "BrowserWindow-module--Maximize--m4mav";
export var AddressBar = "BrowserWindow-module--AddressBar--D204R";
export var Content = "BrowserWindow-module--Content--8152j";